module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "titulo titulo_medio texto_cor-cinza-60 u-margem-inferior-media"
  }, [_vm._v("\n    " + _vm._s(_vm.ordem) + "º Proponente\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "linha-de-dados"
  }, [_c('span', {
    staticClass: "item-de-dado item-de-dado_largo"
  }, [_c('strong', [_vm._v("Nome:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.proponente.Nome))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha-de-dados"
  }, [_c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("CPF:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.proponente.Cpf))])]), _vm._v(" "), _c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("Telefone:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.proponente.Telefone || "NÃO INFORMADO"))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha-de-dados"
  }, [_c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("Renda individual:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.proponente.Renda || "NÃO INFORMADO"))])])]), _vm._v(" "), (_vm.proponente.Conjuge) ? _c('div', {
    staticClass: "conjuge-do-proponente"
  }, [_c('h4', {
    staticClass: "titulo titulo_pequeno texto_cor-cinza-60 u-margem-inferior-media"
  }, [_vm._v("\n      CÔNJUGE (" + _vm._s(_vm.ordem) + "º PROPONENTE)\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "linha-de-dados"
  }, [_c('span', {
    staticClass: "item-de-dado item-de-dado_largo"
  }, [_c('strong', [_vm._v("Nome:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.proponente.Conjuge.Nome))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha-de-dados"
  }, [_c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("CPF:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.proponente.Conjuge.Cpf))])]), _vm._v(" "), _c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("Telefone:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.proponente.Conjuge.Telefone || "NÃO INFORMADO"))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha-de-dados"
  }, [_c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("Renda individual:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.proponente.Conjuge.Renda || "NÃO INFORMADO"))])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-234f0ae3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/components/ProponenteItem.vue
// module id = 1094
// module chunks = 1